// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__Q5Cr8","log":"ModalInventoryLogs_log__1XV5M","date":"ModalInventoryLogs_date__9WsWS","userName":"ModalInventoryLogs_userName__KRcMD"};